import { CalloutInline } from '@modernhealth/vital-components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { useLocale } from '../intl/translations';

export const useTranslationDisclaimer = () => {
  const { locale } = useLocale();
  const translationDisclaimer = (
    <CalloutInline variant="default" showIcon>
      <FormattedMessage defaultMessage="Currently, Circles are only offered in English. We’re working toward offering both translations and Circles in additional languages." />
    </CalloutInline>
  );

  const spanishDisclaimer = (
    <CalloutInline variant="default" showIcon>
      <FormattedMessage
        defaultMessage="Circles are primarily offered in English. We’re working toward offering additional Circles in Spanish. Check out our first Spanish Circle, <spanish-circle>Meditación Guiada en Español</spanish-circle>"
        values={{
          'spanish-circle': (chunk: string) => (
            <Link to="/circle/meditacion-guiada-en-espanol" css={{ textDecoration: 'underline' }}>
              {chunk}
            </Link>
          ),
        }}
      />
    </CalloutInline>
  );

  if (locale === 'en-US') return null;
  if (locale === 'es-LA') return spanishDisclaimer;
  return translationDisclaimer;
};
